/**
 * Hide element if it has not at least one permission
 */

import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  OnDestroy,
  EmbeddedViewRef,
  ChangeDetectorRef,
  OnInit,
} from '@angular/core';
import { PermissionsService } from '../permissions.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/*
 * @example:
 *   <input type="text" placeholder="please no"
 *      *xviIfHasAnyOfPermission="['VenuesInventory.Transfer.Add']">
 *
 *   <input type="text" placeholder="please no"
 *      *xviIfHasAnyOfPermission="['VenuesInventory.Transfer.Add'] appCode 'xvi'">
 */
@Directive({
  selector: '[xviIfHasAnyOfPermission]',
})
export class IfHasAnyOfPermissionDirective implements OnInit, OnDestroy {
  /* eslint-disable @angular-eslint/no-input-rename */
  @Input('xviIfHasAnyOfPermission') public permissions: string[];
  @Input('xviIfHasAnyOfPermissionAppCode') public appCode: string;
  /* eslint-enable @angular-eslint/no-input-rename */
  private context: XVIIfHasAnyOfPermissionContext =
    new XVIIfHasAnyOfPermissionContext();
  private viewRef: EmbeddedViewRef<XVIIfHasAnyOfPermissionContext> | null =
    null;
  private cancelSubscription$: Subject<void> = new Subject<void>();

  public constructor(
    private changeDetector: ChangeDetectorRef,
    private templateRef: TemplateRef<XVIIfHasAnyOfPermissionContext>,
    private viewContainer: ViewContainerRef,
    private permissionsService: PermissionsService,
  ) {}

  public ngOnInit(): void {
    this.context.requiredAnyOfPermission = this.permissions;

    if (
      (!this.permissions || !this.permissions.length) &&
      this.appCode === PermissionsService.defaultAppCode
    ) {
      this.updateView(true);
    } else {
      this.permissionsService
        .trackAnyOfPermissionsChange(this.permissions || [], this.appCode)
        .pipe(takeUntil(this.cancelSubscription$))
        .subscribe((hasPermission) => {
          this.updateView(hasPermission);
        });
    }
  }

  public ngOnDestroy(): void {
    this.cancelSubscription$.next();
  }

  private updateView(hasPermission: boolean): void {
    if (hasPermission) {
      if (!this.viewRef) {
        this.viewContainer.clear();
        if (this.templateRef) {
          this.viewRef = this.viewContainer.createEmbeddedView(
            this.templateRef,
            this.context,
          );
        }
      }
    } else {
      this.viewContainer.clear();
      this.viewRef = null;
    }
    this.changeDetector.markForCheck();
  }
}

/**
 * @stable
 */
export class XVIIfHasAnyOfPermissionContext {
  public requiredAnyOfPermission: string[] = [];
}
